import type * as Types from '../base-types.graphql';

import { gql } from '@apollo/client';
export type GqlWbmFieldsFragment = { id: string, warrantProgramId: string, identityId: string, createdAt: string, updatedAt: string };

export const WbmFieldsFragmentDoc = gql`
    fragment WbmFields on WarrantBoardMember {
  id
  warrantProgramId
  identityId
  createdAt
  updatedAt
}
    `;